import { GrowlNotice } from "./growl-notice";

/**
 * A collection of our most common growls. Expand as needed.
 * Intended to standardize our growl language and reduce repetition.
 */
export type StandardGrowl =
  | "loginError"
  | "formError"
  | "saveFailed"
  | "saveSucceeded";

export const STANDARD_GROWLS: { [key in StandardGrowl]: GrowlNotice } = {
  formError: {
    type: "danger",
    message: "Please fix form errors before submitting."
  },
  loginError: {
    type: "danger",
    message: "Invalid username or password."
  },
  saveFailed: {
    type: "danger",
    message: "Save failed."
  },
  saveSucceeded: {
    type: "success",
    message: "Saved!"
  }
};
